import { Button } from "primereact/button"
import { Tooltip } from "primereact/tooltip"
import { FC, useEffect, useState } from "react"
import { getLaunchesLogs } from "../../services/launches-service"
import { catchResponse } from "../../utils/helperFunctions"
import { error, success } from "../../utils/notifications"
import './launches.css'
import { LaunchesTable } from "./LaunchesTable/LaunchesTable"
import { FiCommand } from "react-icons/fi";
import { RxUpdate } from "react-icons/rx"
import moment from "moment"

export const Launches:FC<any> = () => {

    const [open, setOpen] = useState<boolean>(false)

    const [nuevo, setNuevo] = useState<boolean>(true)

    const [logs, setLogs] = useState<any[]>([])

    const [loadingCheckConnection, setLoadingCheckConnection] = useState<boolean>(false)

    const [flag, setFlag] = useState<boolean>(false)

    
    const handleCheckConnection = async() => {
        try {
            setLoadingCheckConnection(true)
            setTimeout(() => {
                setFlag(!flag)
                setLoadingCheckConnection(false)
                success("Tabla de logs actualizada correctamente")
            },2000)
        } catch(err:any) {
            setLoadingCheckConnection(false)

        }
    }
  
    const handleCloseModal = () => {
        setOpen(false)
        
    }

    const handleOpenEditModal = () => {
        setNuevo(false)
        setOpen(true)
    }

    const fetchLogsInfo = async() => {
        try {
            const res = await getLaunchesLogs()
            if(res.status === 200) {
                const { code, data, message} = res.data
                if(code === 200) {
                    setLogs(data)
                    localStorage.setItem("acc_logs_lu",moment().format('DD/MM/YYYY HH:mm'))
                } else {
                    error(message)
                }
            } else {
                error("Error obteniendo la información")
            }
        } catch(err:any) {
            catchResponse(err)
        }
    }

    useEffect(() => {
        fetchLogsInfo()
    },[flag])

    return (
        <div className="launches__wrapper">
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'35%'}}>
            <Button style={{minWidth:200}} disabled={loadingCheckConnection} label={loadingCheckConnection? "Actualizando logs" : "Actualizar logs"} icon={loadingCheckConnection? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'var(--primary)'}} /> :<RxUpdate style={{fontSize:18,marginRight:'1rem'}} />}  onClick={handleCheckConnection}  outlined />
            <span style={{fontFamily:'var(--roboto-light)',fontSize:'0.95rem',fontStyle:'italic',marginLeft:'1rem',minWidth:280}}> - Última actualización: {localStorage.getItem("acc_logs_lu") ?? 'Sin registros'}</span>
            </div>
            <LaunchesTable
                handleOpenEditModal={handleOpenEditModal}
                handleCloseModal={handleCloseModal}
                data={logs}
                open={open}
                nuevo={nuevo}
                />
        </div>
    )
}